/**
 * Vanilla Read More.
 */
function ReadMore(id, {
  charLength = 100,
  readMoreText = "Read More",
  readLessText = "Read Less",
} = {}) {

  const readMoreElem = document.getElementById(id);
  if (!readMoreElem) {
    return;
  }

  // Set variables.
  let lengthChar = charLength;
  const readMoreLinkText = readMoreText;
  const readLessLinkText = readLessText;

  // Strip HTML comments and trim.
  const targetText = readMoreElem.innerHTML.replace(/<\!--[\s\S]*?-->/g, "").trim();

  // Return if readmore length is less than html length.
  if (targetText.length < lengthChar) {
    return;
  }

  // If the truncated text lands in a link tag, move breakpoint to after the link tag ends.
  let links = readMoreElem.querySelectorAll('a');
  links.forEach(a => {
    let linkOuterHtml = a.outerHTML;
    let linkOuterHtmlLength = a.outerHTML.length;
    let linkStartChar = targetText.indexOf(linkOuterHtml);
    let linkEndChar = linkStartChar + linkOuterHtmlLength;
    if (lengthChar >= linkStartChar && lengthChar <= linkEndChar) {
      lengthChar = linkEndChar;
      return;
    }
  })

  // Get truncated text.
  let truncatedString = targetText.substring(0, lengthChar).trim();

  // Create ellipis and links.
  const ellipsis = '<span style="display:inline;" class="rm-ellipsis">...</span>';
  const readMoreLink = '<a href="#" aria-expanded="false" aria-label="Read more toggle" aria-controls="' + readMoreElem.id + '" class="read-more-link" style="display:inline;font-weight:normal;font-style:normal;">' + readMoreLinkText + '</a>';
  const readLessLink = '<a href="#" aria-expanded="true" aria-label="Read less toggle" aria-controls="' + readMoreElem.id + '" class="read-less-link" style="display:block;font-weight:normal;font-style: normal;">' + readLessLinkText + '</a>';

  // Create truncated text element.
  const truncatedTextElement = document.createElement("div");
  truncatedTextElement.setAttribute("style", "display:inline;");
  truncatedTextElement.setAttribute("class", "truncated-text");
  truncatedTextElement.innerHTML = truncatedString + ellipsis + readMoreLink;

  // Create full text element.
  const full = document.createElement("div");
  full.setAttribute("style", "display:none;");
  full.setAttribute("class", "full");
  full.innerHTML = readMoreElem.innerHTML + readLessLink;

  // Clear text from target element now that we have saved as full.
  readMoreElem.innerHTML = '';

  // Add both truncated and full elements to the page.
  readMoreElem.appendChild(truncatedTextElement);
  readMoreElem.appendChild(full);

  // When read-more/read-less link is clicked, toggle the text visibility.
  const morelinkElement = readMoreElem.querySelector('.read-more-link');
  const lesslinkElement = readMoreElem.querySelector('.read-less-link');
  [morelinkElement, lesslinkElement].forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        if (truncatedTextElement.style.display == "inline") {
          truncatedTextElement.style.display = "none";
          full.style.display = "block";
        }
        else {
          truncatedTextElement.style.display = "inline";
          full.style.display = "none";
        }
    });
  });
}
